import yichang from "./index.vue";
import yichangHome from "./Home.vue";

const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/yichangIndex",
    name: "yichangIndex",
    component: yichangHome
  },
  {
    path: "/yichang/login",
    name: "yichangLogin",
    component: login
  },
  {
    path: "/yichang",
    name: "yichang",
    redirect: "/yichang",
    component: yichang,
    children: [
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
    ]
  }
];
